module.exports = __webpack_public_path__ + "img/StaticWarning.f9f3543b.svg";